import { Candidate } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';

const setCandidateById = (id: string, candidate?: Candidate) => {
    const { candidateStore } = getStore();
    const originalCandidates = candidateStore.candidates;
    const updatedCandidates = originalCandidates.map((originalCandaidate) => {
        if (originalCandaidate?.id === id) {
            return candidate as Candidate;
        }
        return originalCandaidate;
    });
    candidateStore.setCandidates(updatedCandidates);
};

export default setCandidateById;
